import React from "react";
import styles from "./HorizontalBarChart.module.css";

export interface BarItem {
  label: string;
  value: number;
  color?: string;
}

interface HorizontalBarChartProps {
  data: BarItem[];
  maxVisible?: number;
  barHeight?: number;
}

const HorizontalBarChart: React.FC<HorizontalBarChartProps> = ({
  data,
  maxVisible = 10,
  barHeight = 30,
}) => {
  const maxValue = Math.max(...data.map((d) => d.value), 0);
  const n = Math.min(data.length, maxVisible);
  const containerHeight = n * (barHeight + 8) + 24;

  return (
    <div
      className={styles.chartWrapper}
      style={{ maxHeight: `${containerHeight}px` }}
    >
      {data.map((item) => {
        const percent = maxValue ? (item.value / maxValue) * 100 : 0;
        const bg = item.color ?? "linear-gradient(90deg, #6366f1, #4f46e5)";
        return (
          <div
            className={styles.barRow}
            key={item.label}
            style={{ height: `${barHeight}px` }}
          >
            <div className={styles.barLabel}>{item.label}</div>
            <div className={styles.barContainer}>
              <div
                className={styles.bar}
                style={{ width: `${percent}%`, background: bg }}
              >
                <span className={styles.barValue}>{item.value}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HorizontalBarChart;
